import Command from '../../actions/command';
import {call, fork, put, select, take} from 'redux-saga/effects';
import {Action} from 'redux-actions';
import Event from '../../actions/event';
import Api from '../../../api';
import {Selector} from '../../selector';
import {FinalizeSelfAssessmentPayload} from '../../actions/selfAssessmentCommand';

const onFinalizeSelfAssessment = function*(data: FinalizeSelfAssessmentPayload) {
    const selfAssessmentId: string|null = yield select(Selector.SelfAssessment.selfAssessmentId);

    if (!selfAssessmentId) {
        return;
    }

    try {
        yield call(Api.Command.finalizeSelfAssessment, {
            selfAssessmentId,
        });

        yield put(Event.SelfAssessment.selfAssessmentFinalized({}));
    } catch (e) {
        yield put(Command.Notification.enqueueNotification({
            severity: 'error',
            message: 'Die Selbstauskunft konnte nicht finalisiert werden.',
        }));
    }
};

export function* finalizeSelfAssessmentFlow() {
    while (true) {
        const action: Action<FinalizeSelfAssessmentPayload> = yield take(
            Command.SelfAssessment.finalizeSelfAssessment.toString(),
        );

        yield fork(onFinalizeSelfAssessment, action.payload);
    }
}
